module.exports = __webpack_public_path__ + "img/parter-work4.6c3ddfa6.png";